import type { CSSProperties, ReactNode } from "react";

import clsx from "clsx";

import { Tooltip } from "../tooltip";

import styles from "./meter.module.css";

export type MeterBarProps = {
	description: string;
	isRemainder?: boolean;
	share: number;
	toneClassName: string;
};

export function MeterBar({
	description,
	isRemainder = false,
	share,
	toneClassName,
}: MeterBarProps): ReactNode {
	const slotStyle: CSSProperties | undefined = isRemainder
		? undefined
		: { inlineSize: `${share}%` };

	return (
		<div className={clsx(styles.slot, isRemainder && styles.remainderSlot)} style={slotStyle}>
			<Tooltip
				buttonProps={{ ariaLabel: description, className: styles.trigger }}
				needsButton
				text={description}
			>
				<div className={clsx(styles.segment, toneClassName)} />
			</Tooltip>
		</div>
	);
}
